import React from "react";
import { Helmet } from "react-helmet";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import Footer from "../../../components/Layout/Footer/FooterStyleOne";
import SearchModal from "../../../components/Layout/Header/SearchModal";
import ScrollToTop from "../../../components/Common/ScrollTop";
import Newsletter from "../../../components/Common/Newsletter";
import Header from "../../../components/Layout/Header/Header";
import ServiceCard from "../../../components/Service/ServiceCard";
import { Link } from "react-router-dom";

import { FaTachometerAlt, FaDatabase, FaServer, FaChartLine, FaCode, FaCloud, FaCogs, FaRocket } from "react-icons/fa";

import bannerbg from "../../../assets/img/breadcrumbs/sssss.jpg";
import Logo from "../../../assets/img/logo/dark-logo.png";
import footerLogo from "../../../assets/img/logo/lite-logo.png";
import favIcon from "../../../assets/img/fav.png";
import IndustriesSection from "../../home/IndustriesSection";

const serviceCards = [
    {
        icon: <FaTachometerAlt size={80} color="var(--brand-primary)" />,
        title: "Performance Profiling & Analysis",
        description: "Deep-dive analysis to identify performance bottlenecks in your application. We use profiling tools and metrics to pinpoint slow queries, memory leaks, and inefficient code.",
    },
    {
        icon: <FaDatabase size={80} color="var(--brand-primary)" />,
        title: "Database Optimization",
        description: "Optimize database queries, indexes, and schema design for faster data access. We implement caching strategies and query optimization to reduce database load and improve response times.",
    },
    {
        icon: <FaCode size={80} color="var(--brand-primary)" />,
        title: "Code & Algorithm Optimization",
        description: "Refactor inefficient code and optimize algorithms for better performance. We identify computational bottlenecks and implement more efficient solutions without changing functionality.",
    },
    {
        icon: <FaCloud size={80} color="var(--brand-primary)" />,
        title: "Caching Strategies",
        description: "Implement multi-layer caching with Redis, CDN, and application-level caching. We reduce server load and improve response times by serving frequently accessed data from cache.",
    },
    {
        icon: <FaServer size={80} color="var(--brand-primary)" />,
        title: "Load Balancing & Auto-Scaling",
        description: "Distribute traffic efficiently across servers and implement auto-scaling for variable loads. We ensure your application handles traffic spikes without degradation.",
    },
    {
        icon: <FaChartLine size={80} color="var(--brand-primary)" />,
        title: "Scalability Architecture",
        description: "Design systems that scale horizontally to handle millions of users. We implement microservices, message queues, and distributed systems patterns for unlimited growth.",
    },
    {
        icon: <FaCogs size={80} color="var(--brand-primary)" />,
        title: "Infrastructure Optimization",
        description: "Optimize cloud infrastructure for cost and performance. We right-size resources, implement spot instances, and use reserved capacity to reduce costs while maintaining performance.",
    },
    {
        icon: <FaRocket size={80} color="var(--brand-primary)" />,
        title: "Continuous Performance Monitoring",
        description: "Implement monitoring and alerting to track performance metrics in real-time. We set up dashboards and alerts to catch performance regressions before they impact users.",
    },
];

const PerformanceOptimizationScalability = () => {
    return (
        <React.Fragment>
            <Helmet>
                <link rel="icon" href={favIcon} />
                <title>Performance Optimization & Scalability Engineering - Syrol Tech</title>
                <meta name="description" content="We analyze, optimize, and scale applications to handle growth, improve response times, and ensure reliability under high load." />
            </Helmet>
            <OffWrap />
            <Header
                parentMenu="pages"
                secondParentMenu="others"
                headerNormalLogo={Logo}
                headerStickyLogo={Logo}
                CanvasLogo={Logo}
                mobileNormalLogo={Logo}
                CanvasClass="right_menu_togle hidden-md"
                headerClass="full-width-header header-style1 home8-style4"
                TopBar="enable"
                TopBarClass="topbar-area home8-topbar"
                emailAddress="hello@syroltech.com"
                Location="Abuja, Nigeria"
            />
            <SiteBreadcrumb
                pageTitle="Performance Optimization & Scalability Engineering"
                pageName="Performance Optimization & Scalability"
                breadcrumbsImg={bannerbg}
            />
            <section className="consultation-hero-section position-relative w-100" style={{ minHeight: '420px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: `url(${bannerbg}) center/cover no-repeat` }}>
                <div className="hero-overlay" style={{ position: 'absolute', inset: 0, background: 'rgba(10, 18, 32, 0.72)', zIndex: 1 }}></div>
                <div className="container position-relative" style={{ zIndex: 2, maxWidth: '900px', padding: '3rem 1rem', textAlign: 'left' }}>
                    <h1 style={{ color: '#fff', fontWeight: 700, fontSize: '2.6rem', lineHeight: 1.15, marginBottom: '1.2rem' }}>Scale your application to handle millions of users</h1>
                    <p style={{ color: '#fff', fontSize: '1.25rem', maxWidth: '600px', marginBottom: '2.2rem' }}>We analyze, optimize, and scale applications to handle growth, improve response times, and ensure reliability under high load.</p>
                    <Link to="/consultation" className="readon orange-btn" style={{ padding: '12px 28px', fontSize: '1rem', borderRadius: '6px', fontWeight: 700, textDecoration: 'none', display: 'inline-block', transition: 'background 0.2s' }}>Request A Free Proposal</Link>
                </div>
            </section>
            <div className="rs-contact style1 event-bg pt-110 md-pt-10 pb-100 md-pb-80">
                <div className="container pb-66 md-pb-46">
                    <h2 className="service-title mb-32">Our Performance Optimization & Scalability Services</h2>
                    {serviceCards.map((card, idx) => (
                        <ServiceCard
                            key={idx}
                            icon={card.icon}
                            title={card.title}
                            description={card.description}
                        />
                    ))}
                </div>
            </div>
            <IndustriesSection />
            <Newsletter
                sectionClass="rs-newsletter style1 orange-color event-bg mb--90 sm-mb-0 sm-pb-80"
                titleClass="title mb-0 white-color"
            />
            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />
            <SearchModal />
            <ScrollToTop scrollClassName="scrollup orange-color" />
        </React.Fragment>
    );
};

export default PerformanceOptimizationScalability;
